import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';

export default function (task, isBaseline, baselineModelState) {
  if (task.type === constants.TASK_TYPES.button || task.type === constants.TASK_TYPES.milestone) {
    return '';
  }

  if (task.type === constants.TASK_TYPES.project) {
    let total_estimate = 0;

    if (isBaseline) {
      const baselineData = baselineModelState || globalStore.getters['baselines/getActiveBaselineData'](task.gantt_id);
      const originalChildren = globalStore.getters['tasksModel/getAllChildByTask'](task.gantt_id, task.id);

      _.each(originalChildren, child => {
        const baselineTask = _.find(baselineData?.tasks, bt => bt.id === child.id);

        if (baselineTask && baselineTask.type === constants.TASK_TYPES.task) {
          total_estimate += parseFloat(baselineTask.estimation);
        }
      });
    } else {
      const children = globalStore.getters['tasksModel/getAllChildByTask'](task.gantt_id, task.id);

      _.each(children, childTask => {
        if (childTask.type === constants.TASK_TYPES.task) {
          total_estimate += parseFloat(childTask.estimation);
        }
      });
    }

    return `${total_estimate}`;
  }

  return `${task.estimation}`;
}
